function SetupChatShell({ children, rightPanel }) {
  return (
    <div
      data-debug-setup-shell
      className="mx-auto flex h-full w-full flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-lg shadow-gray-200/50"
    >
      <div className={`grid min-h-0 flex-1 ${rightPanel ? 'grid-cols-1 lg:grid-cols-[minmax(0,1fr)_340px]' : 'grid-cols-1'}`}>
        {children}
        {rightPanel && (
          <div className="hidden lg:flex flex-col border-l border-gray-100 overflow-y-auto bg-gray-50/30">
            {rightPanel}
          </div>
        )}
      </div>
    </div>
  )
}

export default SetupChatShell
